/** @format */

import { request } from 'src/utils'
const API = {
  // 查询概览信息
  QueryOverview: '/monitorapi/overviews/QueryOverview',
  // 查询告警次数
  QueryAlertNumbers: '/monitorapi/overviews/QueryAlertNumbers',
  // 查询检查指标
  QueryCheckRules: '/monitorapi/overviews/QueryCheckRules',
  // 创建检查指标
  CreateCheckRule: '/monitorapi/overviews/CreateCheckRule',
  // 查询支持成本优化的产品线
  GetProductList: '/monitorapi/common/getProductList',
  // 获取成本优化实例
  GetCostOptInstances: '/monitorapi/overviews/GetCostOptInstances',
  // 订阅成本优化数据
  SubCostOpt: '/monitorapi/overviews/SubCostOpt',
  // 查询成本优化订阅
  QueryCostOptSub: '/monitorapi/overviews/QueryCostOptSub',
  // 获取订阅productList
  QueryCostProductList: '/monitorapi/common/getProductList'
}

export const QueryOverview = data => {
  return request(API.QueryOverview, {
    method: 'get',
    data: data
  })
}
export const QueryAlertNumbers = data => {
  return request(API.QueryAlertNumbers, {
    method: 'get',
    data: data
  })
}

export const CreateCheckRules = data => {
  return request(API.CreateCheckRule, {
    method: 'post',
    data: data
  })
}

export const SubCostOpt = data => {
  return request(API.SubCostOpt, {
    method: 'get',
    data: data
  })
}
export const QueryCheckRules = data => {
  return request(API.QueryCheckRules, {
    method: 'get',
    data: data
  })
}
export const GetCostOptInstances = data => {
  return request(API.GetCostOptInstances, {
    method: 'get',
    data: data
  })
}

export const QueryCostOptSub = () => {
  return request(API.QueryCostOptSub, {
    method: 'get'
  })
}
export const QueryCostList = () => {
  return request(API.QueryCostProductList, {
    method: 'get',
    data: {
      costOptFlag: 1
    }
  })
}
